import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Dialog, Radio, RadioGroup} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Card from 'components/atoms/Card'
import {styles} from 'components/Dialog/SuccessDialog'
import useNoticeConfirm from 'features/modal/useNoticeConfirm'
import {
  REANALYSIS_REPORT_OPTIONS,
  SUMMARY_REPORT_TYPE,
} from 'pages/Analysis/EEGSummary/constants'

const useStyles = makeStyles(styles)

const NoticeConfirmDialog = () => {
  const classes = useStyles()
  const {t} = useTranslation()
  const {open, title, message, additionalItem, onSelect, onConfirm, onReject} =
    useNoticeConfirm()
  const [selected, setSelected] = useState<number>()

  const checkDisabledBtn = () => {
    if (additionalItem === SUMMARY_REPORT_TYPE && !selected) {
      return true
    }
    return false
  }
  return (
    <Dialog open={open} disableEscapeKeyDown className={classes.root}>
      <Card className={classes.alertRoot}>
        <div>
          <div className={classes.alertContainer}>
            <h2>{title}</h2>
            <Typography variant='h6' style={{whiteSpace: 'pre-line'}}>
              {message}
            </Typography>
            {additionalItem === SUMMARY_REPORT_TYPE && (
              <RadioGroup>
                {REANALYSIS_REPORT_OPTIONS.map((item) => (
                  <div key={item.key}>
                    <Radio
                      color='primary'
                      value={item.key}
                      checked={selected === item.key}
                      onChange={() => {
                        onSelect(item.key)
                        setSelected(item.key)
                      }}
                    />
                    {t(item.label)}
                  </div>
                ))}
              </RadioGroup>
            )}
          </div>

          <div
            className={classes.alertButtonContainer}
            style={{display: 'flex', flexWrap: 'nowrap', gap: 10}}
          >
            <Button
              variant='contained'
              color='default'
              disableElevation
              onClick={onReject}
              style={{color: '#555555'}}
            >
              {t('ICancel')}
            </Button>
            <Button
              variant='contained'
              color='primary'
              disableElevation
              disabled={checkDisabledBtn()}
              onClick={onConfirm}
            >
              {t('IOk')}
            </Button>
          </div>
        </div>
      </Card>
    </Dialog>
  )
}

export default NoticeConfirmDialog
